module.exports = __webpack_public_path__ + "img/TCALCI_specific_female_99.e9586f1c.png";